// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"210":"vendor.footer-component","979":"vendor.web-vitals"}[chunkId] + "." + {"210":"b887586b","979":"544f36bc"}[chunkId] + ".chunk.js";
};